import { api, RouteApi, SearchApi } from "../AxiosInstance";
import {api as superAdminApi} from "../../SuperAdmin/Connections/AxiosInstance"

export function getPlanInfoApi(params, initial,isInLaunchMode) {
  if (initial) {
      let newParams = params
      if (isInLaunchMode === "true") newParams.initialLaunchMode = true
    return api().get("/api/PlanService/GetInitialPlanState", { params:newParams });
  }
  return api().get("/api/PlanService/Get", { params });
}

export function getPlanPreviewInfoApi(params) {
  return api().get("/api/Planning/GetPreviewDataForEditor", { params });
}

export function getPlanLightInfoApi(params) {
  return api().get("/api/Planning/GetById", { params });
}

export function planResetApi(data) {
  return api().post("/api/PlanService/PlanReset", data);
}

export function getPlanStatusApi(params) {
  return api().get("/api/Planning/GetPlanStatus", { params });
}

export function getLiveTrackDriversApi(params) {
  return api().get("/api/LiveTracking/GetDrivers", { params });
}

export function getActualDeliveryMissionApi(params) {
  return api().get("/api/LiveTracking/GetMissionsActualDelivery", { params });
}

export function autoAssignMicrohubsApi(data) {
  return api().post("/api/MicroHub/AutoAssignToMicrohubs", data);
}

export function AddNewPinToPlanApi(data) {
  return api().post("/api/PlanService/AddNewPinToPlan", data);
}

export function EditVehicleNameApi(data) {
  return api().put("/api/PlanService/EditVehicleName", data);
}

export function driverActivationApi(data) {
  return api().put("/api/Dispatch/ActiveMissionToDriver", data);
}

export function DispatchToDriverApi(data) {
  return api().post("/api/Dispatch/DispatchToDriver", data);
}

export function ChangeMissionStatusApi(data) {
  return api().post(
    "/api/DriverLiveTracking/SetMissionStatusForDashboard",
    data
  );
}

export function removeDriverFromPolygonApi(data) {
  return api().post("/api/Dispatch/DeleteMissionFromDriver", data);
}

export function removeDistributorFromPolygonApi(data) {
  return api().post("/api/Dispatch/DeletePolygonFromDistributor", data);
}

export function uploadLastPinApi(data) {
  return api().post("/api/PlanService/AddNewPinToPlanWithFile", data);
}

export function confirmLastPinApi(data) {
  return api().post("/api/PlanState/resetLastHour", data);
}

export function getDriverMissionInfoApi(params) {
  return api().get("/api/LiveTracking/GetDriverMissions", { params });
}

export function changeMissionsOrderApi({ data, clusterId }) {
  return api().post(
    "/api/LiveTracking/ChangeMissionPriority?clusterId=" + clusterId,
    data
  );
}

export function getMissionInfoApi(params) {
  return api().get("/api/LiveTracking/GetMissionInfo", { params });
}

export function getNextPrevPlanApi(params) {
  return api().get("/api/PlanService/NextPreviousPlan", { params });
}

export function getMissionStatusExcelApi(params) {
  return api().get("/api/livetracking/DownloadLiveTrackReport", { params });
}

export function getMissionConfirmationApi(missionId) {
  return api().get(
    "/api/DriverLiveTracking/GetMissionConfirmation" +
      (!!missionId ? `?missionId=${missionId}` : "")
  );
}

export function setMissionConfirmationApi(data) {
  return api().post("/api/DriverLiveTracking/SetMissionConfirmation", data);
}

export function searchLiveTrackApi(params) {
  return api().get("/api/LiveTracking/GetSearchResultLiveTrack", { params });
}

export function getRemainCoordsApi(data) {
  return SearchApi().post("/search/single_without_auth", data);
}

export function getActualRouteApi(params) {
  return RouteApi().get("/api/Report/GetMissionActualRouteOfCluster", {
    params,
  });
}

export function getCityLayerApi(params) {
  return api().get("/api/Resources/GetMapLayersForAccount", { params });
}

export function getChatMessagesApi(params) {
  return api().get("/api/LiveTracking/GetDriversChatMessages", { params });
}

export function autoAssignApi(data) {
  return api().post("/api/Dispatch/AutoAssign", data);
}

export function savePreviewApi(data) {
  return api().post("/api/Planning/SavePreviewResult", data);
}

export function getAllMissionPodApi(params) {
  return api().get("/api/LiveTracking/DownloadAllPOCsOfMission", { params });
}

export function getLivetrackInfoApi(params) {
  return api().get("/api/LiveTracking/GetPlanLiveTrackInfo", { params });
}

export function requestVehicleApi(data) {
  return api().post("/api/PlanService/Request3PLVehicle", data);
}

export function deactivateDrivers(data) {
  return superAdminApi().post("/api/Dispatch/DeactivateDrivers", data);
}